import React, { Component } from 'react';
import { connect } from "react-redux";
import Helping from '../../helpers/Helping';
import Notification from "../layout/Notification";
import Pagination from "react-js-pagination";
import { getAll, destroy, setPagesError } from "../../services/pages.service";
import { setProfileError, addCurrentRoute } from '../../actions/profile_action';
import { MESSAGE, ROLE, PAGES } from '../../config/index';
import CreatePage from './Create';

const { NOT_FOUND } = MESSAGE;
class List extends Component {
    constructor(props) {
        super(props);

        this.state = {
            url: URL,
            routeName: '',
            error_message: '',
            error_type: '',
            btnIsEnable: false,
            isLoading: true,
            total: 0,
            activePage: 1,
            limit: PAGES.LIMIT,
            search: props.search,
            sorting: 'id',
            sort_type: 'DESC',
            is_order: false,
            id: '',
            edit_id: '',
            slideModal: ''
        };

        this.handlePageChange = this.handlePageChange.bind(this);
        this.handleSearchChange = this.handleSearchChange.bind(this);
        this.handleLimitChange = this.handleLimitChange.bind(this);
        this.pageRefreshFunction = this.pageRefreshFunction.bind(this);
        this.sortBy = this.sortBy.bind(this);
        this.closeEditModal = this.closeEditModal.bind(this);
    }

    setErrorOnApiCall = () => {
        setProfileError(res => this.setState({ ...res }));
        setPagesError(res => this.setState({ ...res }));
    }

    removeNetworkError = () => {
        this.setState({ ...Helping.clearNetworkRequest(), ...Helping.clearDateRequest() });
    }

    componentDidMount() {
        const { pathname, error_message } = this.props.location;

        this.setState({
            routeName: pathname,
            error_message: error_message
        });

        this.setErrorOnApiCall();
        this.props.addCurrentRoute(this.props.profile, pathname);

        if (this.props.isLoading == true && this.props.pages.length < 1) {
            this.getPages();
        }
    }

    scrollToTop = () => {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth'
        });
    }

    pageRefreshFunction(e) {
        e.preventDefault();

        this.setState({
            search: "",
            activePage: 1,
            error_message: "",
            error_type: ""
        },
            () => this.getPages()
        );
    }

    openCreateModal = () => {
        this.setState({ edit_id: '', slideModal: true }, () => window.openSlideModal())
    }

    openEditModal = (e, object) => {
        this.setState({ edit_id: object.id, slideModal: true }, () => window.openSlideModal())
    }

    closeEditModal() {
        this.setState({
            edit_id: '',
            id: '',
            slideModal: false
        },
            () => window.closeSlideModal())
    }

    openConfirmationModal = (e, object) => {
        this.setState({ id: object.id });
    }

    closeConfirmationModal = () => {
        window.$('#exampleDeleteModal').modal('hide');
        this.setState({
            id: ''
        });
    }

    getPages = () => {
        let search = this.state.search;
        this.props.getAll(this.state.activePage, this.state.limit,
            this.state.sorting, this.state.sort_type, search.trim());
    }

    handlePageChange(pageNumber) {
        if (this.props.page === pageNumber) {
            return false;
        }

        this.setState({
            activePage: pageNumber,
            isLoading: true
        }, () => {
            this.getPages();
        });
    }

    handleLimitChange(itemsLimit) {
        if (this.state.limit === itemsLimit) {
            return false;
        }
        this.setState({
            limit: itemsLimit,
            activePage: 1,
            isLoading: true
        }, () => {
            this.getPages();
        });
    }

    handleSearchChange(e) {
        let $this = this,
            searchValue = e.target.value.replace(/^\s+/g, '');

        if (this.state.search !== searchValue) {
            this.setState({
                search: searchValue,
                activePage: 1
            }, () => {
                if (searchValue.length > 0) {
                    $this.getPages();
                }

                if (searchValue.length === 0) {
                    $this.getPages();
                }
            });
        }
    }

    sortBy(key) {
        let $this = this;
        let sortType = this.state.sort_type;

        if (this.state.sort_type === 'ASC') {
            sortType = 'DESC';
        }

        if (this.state.sort_type === 'DESC') {
            sortType = 'ASC';
        }

        this.setState({
            sorting: key,
            activePage: 1,
            is_order: true,
            sort_type: sortType,
        }, () => {
            $this.removeNetworkError(); $this.getPages();
        });
    }

    render() {
        let role_access = {}, isAdmin = false;

        if (Object.keys(this.props.profile).length > 0) {
            role_access = JSON.parse(this.props.profile.role_access);
            isAdmin = role_access.role === ROLE.ADMIN.toLowerCase();
        }
        let writeAccess = isAdmin;

        return (
            <>
                {(writeAccess && this.state.slideModal) &&
                    <CreatePage id={this.state.edit_id} closeEditModal={this.closeEditModal} />
                }

                <div class="content user-list">
                    <div class="top-header">
                        <div class="header-title">
                            <h2 class="title">Pages</h2>
                            <span class="title-caption">You have total {this.props.total} pages</span>

                            {/*  SEARCH BAR  */}
                            <form class="listing-search-form" onSubmit={(e) => e.preventDefault()}>
                                <span class="search-icon">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="17.999" viewBox="0 0 18 17.999">
                                        <path id="search_Icon" data-name="search Icon" d="M9.583,2a7.579,7.579,0,1,0,4.644,13.56l4.159,4.155a.944.944,0,0,0,1.337.011.973.973,0,0,0,0-1.361L15.56,14.228A7.567,7.567,0,0,0,9.583,2Zm0,1.895A5.684,5.684,0,1,1,3.895,9.579,5.684,5.684,0,0,1,9.579,3.895Z" transform="translate(-2 -2)" />
                                    </svg>
                                </span>
                                <input class="form-control" type="search" placeholder="Search in Pages" aria-label="Search" value={this.state.search} onChange={(e) => this.handleSearchChange(e)} />
                            </form>
                            {/*  SEARCH BAR END  */}
                        </div>

                        <div class="header-btn">
                            <button class="custom-btn icon-btn dark-btn sm-btn" onClick={this.pageRefreshFunction}>
                                <svg id="refresh" xmlns="http://www.w3.org/2000/svg" width="18" height="20" viewBox="0 0 18 20">
                                    <path id="Path_449" data-name="Path 449" d="M313.164,391.557c-.048-.293-.092-.582-.142-.871a1.127,1.127,0,0,1,.858-1.384,1.064,1.064,0,0,1,1.23.963q.326,1.894.628,3.794a1.1,1.1,0,0,1-.933,1.327l-3.615.643a1.065,1.065,0,0,1-1.262-.888,1.1,1.1,0,0,1,.854-1.288c.438-.095.882-.163,1.378-.252-.108-.068-.173-.113-.242-.151a6.869,6.869,0,0,0-10.015,5.356,7.187,7.187,0,0,0,5.554,8.138,6.961,6.961,0,0,0,8.137-5.977,1.081,1.081,0,0,1,1-.984,1.024,1.024,0,0,1,1.063.8,2.485,2.485,0,0,1-.027.9,9.223,9.223,0,0,1-7.31,7.461,9.074,9.074,0,0,1-10.447-7.421,9.412,9.412,0,0,1,7.2-11.144,8.62,8.62,0,0,1,5.859.9c.053.028.1.056.158.082A.241.241,0,0,0,313.164,391.557Z" transform="translate(-299.689 -389.283)" />
                                </svg>
                                <span class="txt-btn">Refresh</span>
                            </button>
                            {/* {writeAccess &&
                                <button class="custom-btn gradiant-btn sm-btn" id="addButton" onClick={() => this.openCreateModal()}>Add New Page</button>
                            } */}
                        </div>
                    </div>

                    <div class="main-content">
                        {this.state.error_message &&
                            <Notification
                                type={this.state.error_type}
                                message={this.state.error_message}
                                callback={this.removeNetworkError}
                            />
                        }
                        <div class="user-listing-tbl table-responsive">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th class="tbl-sorting" scope="col" onClick={() => this.sortBy('id')}>
                                            ID
                                            <span class={`icon ascending ${this.state.sort_type === 'ASC' && this.state.sorting === 'id' ? 'active' : ''}`}><svg xmlns="http://www.w3.org/2000/svg" width="16" height="12.001" viewBox="0 0 16 12.001"><g id="Group_187" data-name="Group 187" transform="translate(-2.475 -12.975)"><g id="Group_186" data-name="Group 186" transform="translate(2.475 12.975)"><path id="Path_420" data-name="Path 420" d="M2.693,22.32l2.425,2.425a.771.771,0,0,0,1.1,0L8.643,22.32a.777.777,0,0,0-1.1-1.1l-1.1,1.1V13.751a.776.776,0,1,0-1.552,0V22.32l-1.1-1.1a.781.781,0,0,0-1.1,0A.8.8,0,0,0,2.693,22.32Z" transform="translate(-2.475 -12.975)" /><path id="Path_421" data-name="Path 421" d="M60.576,79.086h4.543a.776.776,0,0,0,.776-.776.753.753,0,0,0-.776-.76H60.576a.776.776,0,0,0-.776.776A.753.753,0,0,0,60.576,79.086Z" transform="translate(-49.895 -67.11)" /><path id="Path_422" data-name="Path 422" d="M49.023,13H41.376a.776.776,0,0,0-.776.776.766.766,0,0,0,.776.776h7.647a.776.776,0,0,0,.776-.776A.766.766,0,0,0,49.023,13Z" transform="translate(-33.8 -12.996)" /><path id="Path_423" data-name="Path 423" d="M54.389,34.5H47.776a.776.776,0,0,0,0,1.552h6.613a.776.776,0,0,0,.776-.776A.766.766,0,0,0,54.389,34.5Z" transform="translate(-39.165 -31.02)" /><path id="Path_424" data-name="Path 424" d="M59.754,56H54.176a.776.776,0,0,0-.776.776.766.766,0,0,0,.776.776h5.578a.776.776,0,0,0,.776-.776A.766.766,0,0,0,59.754,56Z" transform="translate(-44.53 -49.044)" /></g></g></svg></span>
                                            <span class={`icon descending ${this.state.sort_type === 'DESC' && this.state.sorting === 'id' ? 'active' : ''}`}><svg xmlns="http://www.w3.org/2000/svg" width="16" height="12" viewBox="0 0 16 12"><g id="Group_185" data-name="Group 185" transform="translate(-2.475 -12.975)"><g id="Group_184" data-name="Group 184" transform="translate(2.475 12.975)"><path id="Path_415" data-name="Path 415" d="M8.807,15.63,6.322,13.205a.8.8,0,0,0-1.126,0L2.711,15.63a.758.758,0,0,0,0,1.1.8.8,0,0,0,1.126,0l1.126-1.1V24.2a.8.8,0,0,0,1.59,0V15.63l1.126,1.1a.814.814,0,0,0,1.126,0A.787.787,0,0,0,8.807,15.63Z" transform="translate(-2.475 -12.975)" /><path id="Path_416" data-name="Path 416" d="M60.6,14.574h4.654a.8.8,0,0,0,.8-.8.771.771,0,0,0-.8-.778H60.6a.8.8,0,0,0-.8.8A.771.771,0,0,0,60.6,14.574Z" transform="translate(-50.045 -12.996)" /><path id="Path_417" data-name="Path 417" d="M49.23,77.5H41.4a.8.8,0,0,0-.8.8.785.785,0,0,0,.8.8H49.23a.8.8,0,0,0,.8-.8A.785.785,0,0,0,49.23,77.5Z" transform="translate(-34.025 -67.107)" /><path id="Path_418" data-name="Path 418" d="M54.57,56H47.8a.8.8,0,0,0,0,1.59H54.57a.8.8,0,0,0,.8-.8A.785.785,0,0,0,54.57,56Z" transform="translate(-39.365 -49.069)" /><path id="Path_419" data-name="Path 419" d="M59.91,34.5H54.2a.8.8,0,0,0-.8.8.785.785,0,0,0,.8.8H59.91a.8.8,0,0,0,.8-.8A.785.785,0,0,0,59.91,34.5Z" transform="translate(-44.705 -31.033)" /></g></g></svg></span>
                                        </th>
                                        <th class="tbl-sorting" scope="col" onClick={() => this.sortBy('title')}>
                                            Title
                                            <span class={`icon ascending ${this.state.sort_type === 'ASC' && this.state.sorting === 'title' ? 'active' : ''}`}><svg xmlns="http://www.w3.org/2000/svg" width="16" height="12.001" viewBox="0 0 16 12.001"><g id="Group_187" data-name="Group 187" transform="translate(-2.475 -12.975)"><g id="Group_186" data-name="Group 186" transform="translate(2.475 12.975)"><path id="Path_420" data-name="Path 420" d="M2.693,22.32l2.425,2.425a.771.771,0,0,0,1.1,0L8.643,22.32a.777.777,0,0,0-1.1-1.1l-1.1,1.1V13.751a.776.776,0,1,0-1.552,0V22.32l-1.1-1.1a.781.781,0,0,0-1.1,0A.8.8,0,0,0,2.693,22.32Z" transform="translate(-2.475 -12.975)" /><path id="Path_421" data-name="Path 421" d="M60.576,79.086h4.543a.776.776,0,0,0,.776-.776.753.753,0,0,0-.776-.76H60.576a.776.776,0,0,0-.776.776A.753.753,0,0,0,60.576,79.086Z" transform="translate(-49.895 -67.11)" /><path id="Path_422" data-name="Path 422" d="M49.023,13H41.376a.776.776,0,0,0-.776.776.766.766,0,0,0,.776.776h7.647a.776.776,0,0,0,.776-.776A.766.766,0,0,0,49.023,13Z" transform="translate(-33.8 -12.996)" /><path id="Path_423" data-name="Path 423" d="M54.389,34.5H47.776a.776.776,0,0,0,0,1.552h6.613a.776.776,0,0,0,.776-.776A.766.766,0,0,0,54.389,34.5Z" transform="translate(-39.165 -31.02)" /><path id="Path_424" data-name="Path 424" d="M59.754,56H54.176a.776.776,0,0,0-.776.776.766.766,0,0,0,.776.776h5.578a.776.776,0,0,0,.776-.776A.766.766,0,0,0,59.754,56Z" transform="translate(-44.53 -49.044)" /></g></g></svg></span>
                                            <span class={`icon descending ${this.state.sort_type === 'DESC' && this.state.sorting === 'title' ? 'active' : ''}`}><svg xmlns="http://www.w3.org/2000/svg" width="16" height="12" viewBox="0 0 16 12"><g id="Group_185" data-name="Group 185" transform="translate(-2.475 -12.975)"><g id="Group_184" data-name="Group 184" transform="translate(2.475 12.975)"><path id="Path_415" data-name="Path 415" d="M8.807,15.63,6.322,13.205a.8.8,0,0,0-1.126,0L2.711,15.63a.758.758,0,0,0,0,1.1.8.8,0,0,0,1.126,0l1.126-1.1V24.2a.8.8,0,0,0,1.59,0V15.63l1.126,1.1a.814.814,0,0,0,1.126,0A.787.787,0,0,0,8.807,15.63Z" transform="translate(-2.475 -12.975)" /><path id="Path_416" data-name="Path 416" d="M60.6,14.574h4.654a.8.8,0,0,0,.8-.8.771.771,0,0,0-.8-.778H60.6a.8.8,0,0,0-.8.8A.771.771,0,0,0,60.6,14.574Z" transform="translate(-50.045 -12.996)" /><path id="Path_417" data-name="Path 417" d="M49.23,77.5H41.4a.8.8,0,0,0-.8.8.785.785,0,0,0,.8.8H49.23a.8.8,0,0,0,.8-.8A.785.785,0,0,0,49.23,77.5Z" transform="translate(-34.025 -67.107)" /><path id="Path_418" data-name="Path 418" d="M54.57,56H47.8a.8.8,0,0,0,0,1.59H54.57a.8.8,0,0,0,.8-.8A.785.785,0,0,0,54.57,56Z" transform="translate(-39.365 -49.069)" /><path id="Path_419" data-name="Path 419" d="M59.91,34.5H54.2a.8.8,0,0,0-.8.8.785.785,0,0,0,.8.8H59.91a.8.8,0,0,0,.8-.8A.785.785,0,0,0,59.91,34.5Z" transform="translate(-44.705 -31.033)" /></g></g></svg></span>
                                        </th>
                                        <th class="tbl-sorting" scope="col" onClick={() => this.sortBy('code')}>
                                            Permalink
                                            <span class={`icon ascending ${this.state.sort_type === 'ASC' && this.state.sorting === 'code' ? 'active' : ''}`}><svg xmlns="http://www.w3.org/2000/svg" width="16" height="12.001" viewBox="0 0 16 12.001"><g id="Group_187" data-name="Group 187" transform="translate(-2.475 -12.975)"><g id="Group_186" data-name="Group 186" transform="translate(2.475 12.975)"><path id="Path_420" data-name="Path 420" d="M2.693,22.32l2.425,2.425a.771.771,0,0,0,1.1,0L8.643,22.32a.777.777,0,0,0-1.1-1.1l-1.1,1.1V13.751a.776.776,0,1,0-1.552,0V22.32l-1.1-1.1a.781.781,0,0,0-1.1,0A.8.8,0,0,0,2.693,22.32Z" transform="translate(-2.475 -12.975)" /><path id="Path_421" data-name="Path 421" d="M60.576,79.086h4.543a.776.776,0,0,0,.776-.776.753.753,0,0,0-.776-.76H60.576a.776.776,0,0,0-.776.776A.753.753,0,0,0,60.576,79.086Z" transform="translate(-49.895 -67.11)" /><path id="Path_422" data-name="Path 422" d="M49.023,13H41.376a.776.776,0,0,0-.776.776.766.766,0,0,0,.776.776h7.647a.776.776,0,0,0,.776-.776A.766.766,0,0,0,49.023,13Z" transform="translate(-33.8 -12.996)" /><path id="Path_423" data-name="Path 423" d="M54.389,34.5H47.776a.776.776,0,0,0,0,1.552h6.613a.776.776,0,0,0,.776-.776A.766.766,0,0,0,54.389,34.5Z" transform="translate(-39.165 -31.02)" /><path id="Path_424" data-name="Path 424" d="M59.754,56H54.176a.776.776,0,0,0-.776.776.766.766,0,0,0,.776.776h5.578a.776.776,0,0,0,.776-.776A.766.766,0,0,0,59.754,56Z" transform="translate(-44.53 -49.044)" /></g></g></svg></span>
                                            <span class={`icon descending ${this.state.sort_type === 'DESC' && this.state.sorting === 'code' ? 'active' : ''}`}><svg xmlns="http://www.w3.org/2000/svg" width="16" height="12" viewBox="0 0 16 12"><g id="Group_185" data-name="Group 185" transform="translate(-2.475 -12.975)"><g id="Group_184" data-name="Group 184" transform="translate(2.475 12.975)"><path id="Path_415" data-name="Path 415" d="M8.807,15.63,6.322,13.205a.8.8,0,0,0-1.126,0L2.711,15.63a.758.758,0,0,0,0,1.1.8.8,0,0,0,1.126,0l1.126-1.1V24.2a.8.8,0,0,0,1.59,0V15.63l1.126,1.1a.814.814,0,0,0,1.126,0A.787.787,0,0,0,8.807,15.63Z" transform="translate(-2.475 -12.975)" /><path id="Path_416" data-name="Path 416" d="M60.6,14.574h4.654a.8.8,0,0,0,.8-.8.771.771,0,0,0-.8-.778H60.6a.8.8,0,0,0-.8.8A.771.771,0,0,0,60.6,14.574Z" transform="translate(-50.045 -12.996)" /><path id="Path_417" data-name="Path 417" d="M49.23,77.5H41.4a.8.8,0,0,0-.8.8.785.785,0,0,0,.8.8H49.23a.8.8,0,0,0,.8-.8A.785.785,0,0,0,49.23,77.5Z" transform="translate(-34.025 -67.107)" /><path id="Path_418" data-name="Path 418" d="M54.57,56H47.8a.8.8,0,0,0,0,1.59H54.57a.8.8,0,0,0,.8-.8A.785.785,0,0,0,54.57,56Z" transform="translate(-39.365 -49.069)" /><path id="Path_419" data-name="Path 419" d="M59.91,34.5H54.2a.8.8,0,0,0-.8.8.785.785,0,0,0,.8.8H59.91a.8.8,0,0,0,.8-.8A.785.785,0,0,0,59.91,34.5Z" transform="translate(-44.705 -31.033)" /></g></g></svg></span>
                                        </th>
                                        <th class="tbl-sorting" scope="col" onClick={() => this.sortBy('created_at')}>
                                            Date Created
                                            <span class={`icon ascending ${this.state.sort_type === 'ASC' && this.state.sorting === 'created_at' ? 'active' : ''}`}><svg xmlns="http://www.w3.org/2000/svg" width="16" height="12.001" viewBox="0 0 16 12.001"><g id="Group_187" data-name="Group 187" transform="translate(-2.475 -12.975)"><g id="Group_186" data-name="Group 186" transform="translate(2.475 12.975)"><path id="Path_420" data-name="Path 420" d="M2.693,22.32l2.425,2.425a.771.771,0,0,0,1.1,0L8.643,22.32a.777.777,0,0,0-1.1-1.1l-1.1,1.1V13.751a.776.776,0,1,0-1.552,0V22.32l-1.1-1.1a.781.781,0,0,0-1.1,0A.8.8,0,0,0,2.693,22.32Z" transform="translate(-2.475 -12.975)" /><path id="Path_421" data-name="Path 421" d="M60.576,79.086h4.543a.776.776,0,0,0,.776-.776.753.753,0,0,0-.776-.76H60.576a.776.776,0,0,0-.776.776A.753.753,0,0,0,60.576,79.086Z" transform="translate(-49.895 -67.11)" /><path id="Path_422" data-name="Path 422" d="M49.023,13H41.376a.776.776,0,0,0-.776.776.766.766,0,0,0,.776.776h7.647a.776.776,0,0,0,.776-.776A.766.766,0,0,0,49.023,13Z" transform="translate(-33.8 -12.996)" /><path id="Path_423" data-name="Path 423" d="M54.389,34.5H47.776a.776.776,0,0,0,0,1.552h6.613a.776.776,0,0,0,.776-.776A.766.766,0,0,0,54.389,34.5Z" transform="translate(-39.165 -31.02)" /><path id="Path_424" data-name="Path 424" d="M59.754,56H54.176a.776.776,0,0,0-.776.776.766.766,0,0,0,.776.776h5.578a.776.776,0,0,0,.776-.776A.766.766,0,0,0,59.754,56Z" transform="translate(-44.53 -49.044)" /></g></g></svg></span>
                                            <span class={`icon descending ${this.state.sort_type === 'DESC' && this.state.sorting === 'created_at' ? 'active' : ''}`}><svg xmlns="http://www.w3.org/2000/svg" width="16" height="12" viewBox="0 0 16 12"><g id="Group_185" data-name="Group 185" transform="translate(-2.475 -12.975)"><g id="Group_184" data-name="Group 184" transform="translate(2.475 12.975)"><path id="Path_415" data-name="Path 415" d="M8.807,15.63,6.322,13.205a.8.8,0,0,0-1.126,0L2.711,15.63a.758.758,0,0,0,0,1.1.8.8,0,0,0,1.126,0l1.126-1.1V24.2a.8.8,0,0,0,1.59,0V15.63l1.126,1.1a.814.814,0,0,0,1.126,0A.787.787,0,0,0,8.807,15.63Z" transform="translate(-2.475 -12.975)" /><path id="Path_416" data-name="Path 416" d="M60.6,14.574h4.654a.8.8,0,0,0,.8-.8.771.771,0,0,0-.8-.778H60.6a.8.8,0,0,0-.8.8A.771.771,0,0,0,60.6,14.574Z" transform="translate(-50.045 -12.996)" /><path id="Path_417" data-name="Path 417" d="M49.23,77.5H41.4a.8.8,0,0,0-.8.8.785.785,0,0,0,.8.8H49.23a.8.8,0,0,0,.8-.8A.785.785,0,0,0,49.23,77.5Z" transform="translate(-34.025 -67.107)" /><path id="Path_418" data-name="Path 418" d="M54.57,56H47.8a.8.8,0,0,0,0,1.59H54.57a.8.8,0,0,0,.8-.8A.785.785,0,0,0,54.57,56Z" transform="translate(-39.365 -49.069)" /><path id="Path_419" data-name="Path 419" d="M59.91,34.5H54.2a.8.8,0,0,0-.8.8.785.785,0,0,0,.8.8H59.91a.8.8,0,0,0,.8-.8A.785.785,0,0,0,59.91,34.5Z" transform="translate(-44.705 -31.033)" /></g></g></svg></span>
                                        </th>
                                        {writeAccess &&
                                            <th scope="col">Actions</th>
                                        }
                                    </tr>
                                </thead>
                                {(this.props.total > 0 && !this.props.isLoading) && (
                                    <tbody>
                                        {this.props.pages.map((page, i) => (
                                            <tr key={i}>
                                                <td scope="row">{page.id}</td>
                                                <td>{page.title}</td>
                                                <td>{page.code}</td>
                                                <td>
                                                    <div class=" ">
                                                        {Helping.convertTimeToHumanReadableFormat(
                                                            page.created_at
                                                        )}
                                                    </div>
                                                </td>
            
                                                {writeAccess && (
                                                    <td>
                                                        <div class="action-links">
                                                            <button type="button" class="icon edit" onClick={(e) => this.openEditModal(e, page)}>
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                                                                    <path id="edit" d="M17,2a1.02,1.02,0,0,0-.719.281l-2,2-8,8A1.02,1.02,0,0,0,6,13v4a1,1,0,0,0,1,1h4a1.02,1.02,0,0,0,.719-.281l8-8,2-2A1.02,1.02,0,0,0,22,7a4.944,4.944,0,0,0-1.281-3.687A4.849,4.849,0,0,0,17,2Zm.375,2.063a2.753,2.753,0,0,1,1.906.625,2.92,2.92,0,0,1,.656,1.937L19,7.563,16.437,5ZM15,6.438,17.562,9l-7,7H8V13.438ZM10,4a1,1,0,0,1,0,2H6A2,2,0,0,0,4,8V18a2,2,0,0,0,2,2H16a2,2,0,0,0,2-2V14a1,1,0,0,1,2,0v4a4,4,0,0,1-4,4H6a4,4,0,0,1-4-4V8A4,4,0,0,1,6,4Z" transform="translate(-2 -2)" />
                                                                </svg>
                                                            </button>

                                                            {/* <button
                                                                type='button'
                                                                class="icon delete"
                                                                data-toggle="modal" data-target="#exampleDeleteModal"
                                                                onClick={(e) => this.openConfirmationModal(e, page)}
                                                            >
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="20" viewBox="0 0 18 20">
                                                                    <path id="delete" d="M11.073,11.953V16.93a1,1,0,0,1-2,0V11.953a1,1,0,0,1,2,0Zm3-.995a1,1,0,0,0-1,.995V16.93a1,1,0,0,0,2,0V11.953A1,1,0,0,0,14.073,10.958Zm-8-.032a1,1,0,0,0-1,1v6a3.959,3.959,0,0,0,3.969,3.95l6.031.031a3.955,3.955,0,0,0,3.969-3.95v-6a1,1,0,0,0-2,0v6a1.964,1.964,0,0,1-1.969,1.96l-6.031-.032a1.96,1.96,0,0,1-1.969-1.959v-6A1,1,0,0,0,6.073,10.926Zm15-5.07V7.972a1,1,0,0,1-1,.995h-16a1,1,0,0,1-1-.995v-1.9A3.972,3.972,0,0,1,7.011,2.093L17.1,1.906A3.959,3.959,0,0,1,21.073,5.856ZM7.042,4.084a1.989,1.989,0,0,0-1.969,1.99v.9h14V5.856A1.95,1.95,0,0,0,17.135,3.9Z" transform="translate(-3.073 -1.906)" />
                                                                </svg>
                                                            </button> */}
                                                        </div>
                                                    </td>
                                                )}
                                            </tr>
                                        ))}
                                    </tbody>
                                )}
                            </table>
                        </div>
                        {this.props.total > 0 && (
                            <div class="table-bottom">
                                <div class="dataTables_length">
                                    <label>Show
                                        <select
                                            name="userDataTable_length"
                                            value={this.props.limit}
                                            onChange={(e) => this.handleLimitChange(e.target.value)}
                                        >
                                            <option value="10">10</option>
                                            <option value="25">25</option>
                                            <option value="50">50</option>
                                            <option value="100">100</option>
                                        </select> of {this.props.total}</label>
                                </div>
                                <Pagination
                                    // hideFirstLastPages
                                    activePage={this.props.page}
                                    itemsCountPerPage={this.props.limit}
                                    totalItemsCount={this.props.total}
                                    pageRangeDisplayed={5}
                                    onChange={this.handlePageChange}
                                    itemClass='page-item'
                                    linkClass='page-link'
                                    prevPageText='Pre'
                                    nextPageText='Next'
                                    firstPageText='First'
                                    lastPageText='Last'
                                    innerClass="dataTables_paginate"
                                    linkClass="paginate_button"
                                    activeLinkClass="paginate_button current"
                                    disabledClass="paginate_button disabled"
                                />
                            </div>
                        )}

                        {(this.props.total < 1 && !this.props.isLoading) && (
                            <div className='table-responsive'>
                                <Notification
                                    type='danger'
                                    message={Helping.getMessageString(
                                        NOT_FOUND,
                                        'Pages '
                                    )}
                                    callback={this.removeNetworkError}
                                />
                            </div>
                        )}
                    </div>
                </div>
            </>
        )
    }
}

const mapStateToProps = state => {
    return {
        pages: state.pages,
        profile: state.profile,
        total: state.fetchPagesMeta.total,
        isLoading: state.fetchPagesMeta.isLoading,
        page: state.fetchPagesMeta.page,
        search: state.fetchPagesMeta.search,
        limit: state.fetchPagesMeta.limit,
        no_Of_pages: state.fetchPagesMeta.no_Of_pages
    }
}

const mapDispatchToProps = {
    getAll,
    addCurrentRoute
}

export default connect(mapStateToProps, mapDispatchToProps)(List)